import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  MenuItem,
  CssBaseline,
  Autocomplete,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MUIDataTable from "mui-datatables";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EventNoteIcon from "@mui/icons-material/EventNote";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DatePicker from "../../Components/DatePicker";
import "./Leads.css";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import LeadDialog from "./LeadDialog";
import { useNavigate } from "react-router-dom";
import { categoryType } from "../../utils/customers";
import { useLocalStorageContext } from "../../Context/LocalProvider";
import {
  DriverApis,
  leadsApis,
  leadSalesApis,
  LeadSourceSettingsApi,
  LeadAgentsSettingsApi,
} from "../../Data/axios";
import config from "../../Data/AuthUser";
import { useSelector } from "react-redux";
import LeadsHeader from "./LeadsHeader";
import AddLead from "./AddLead";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function Leads() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const { data: userData } = useLocalStorageContext();
  const [update, setUpdate] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [leadFiles, setLeadFiles] = useState([]);
  const [optionsAgent, setOptionsAgent] = useState([]);
  const [pageValue, setPageValue] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [selection, setSelection] = useState(null);
  const [selectionStatus, setSelectionStatus] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [followup, setFollowup] = React.useState(false);
  const [leadAgents, setLeadAgents] = useState([]);
  const [rowCountValue, setRowCountValue] = useState(10);
  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });
  const navigate = useNavigate();
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
 const [openAddModal, setOpenAddModal] = useState(false);
  
  // Add these handlers
  const handleOpenAddModal = () => {
    setOpenAddModal(true);
  };

  const handleCloseAddModal = () => {
    setOpenAddModal(false);
  };

  const handleLeadAdded = () => {
    showAlert("Lead added successfully", "success");
    getData();
  };
  const closeDropMenu = () => {
    setAnchorEl(null);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };
  const handleClickFollowup = () => {
    setFollowup(true);
  };
  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleUpdateCloseFollow = () => {
    setFollowup(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = async () => {
    const rowData = await leadsApis.viewMoreById(openMenuId);

    navigate(`/leads/${openMenuId}`, { state: rowData.data });
  };
  const handleConverted = async () => {
    await leadsApis.convertedbyId(openMenuId);
    getData();
  };
  const handleDailogClosing = () => {
    setSelectedRow({ ...selectedRow, open: false });
  };
  const handleChangeSelected = async (event, ticketId) => {
    const selectedValue = event.target.value;
    const itemStatus = {
      status: selectedValue,
    };
    const formData = new FormData();

    for (const key in itemStatus) {
      if (itemStatus[key] !== undefined && itemStatus[key] !== null) {
        formData.append(key, itemStatus[key]);
      }
    }
    await DriverApis.changeStatus(ticketId, formData);
    showAlert("updated successfully", "success");
    getData();
  };
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [language, setLanguage] = React.useState("");
  const [role, setRole] = React.useState([]);
  const [lead_agent, setLead_agent] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [leas_source, setLeas_source] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [updaterole, setUpdaterole] = useState("");
  const [updatelanguage, setUpdatelanguage] = useState("");
  const [updateaddress, setUpdateaddress] = useState("");
  const [updatelead_agent, setUpdatelead_agent] = useState("");
  const [updatename, setUpdatename] = useState("");
  const [updatephone, setUpdatephone] = useState("");
  const [updateemail, setUpdateemail] = useState("");
  const [updateleas_source, setUpdateleas_source] = useState("");
  const [data, setData] = useState([]);
  const [follow_agent, setFollow_agent] = useState("");
  const [follow_date, setFollow_date] = useState("");

  const [leadSources, setLeadSources] = useState([]);

  const [openMenuId, setOpenMenuId] = useState(null);
  const handleGenderChange = (event) => {
    setRole(event.target.value);
  };

  const handleGenderChangeupdate = (event) => {
    setUpdaterole(event.target.value);
  };

  const handleLeadAgentChange = (event) => {
    setLead_agent(event.target.value);
  };

  const handleLeadSourceChange = (event) => {
    setLeas_source(event.target.value);
  };

  const categoryKeys = Object.keys(categoryType);
  const item = {
    language,
    address,
    lead_agent,
    leas_source,
    phone,
    email,
    name,
    role,
  };

  // Transform API data to the format needed for dropdown
  const leadSourceOptions =
    leadSources?.map((source) => {
      console.log("Mapping source:", source);
      return {
        id: source.id,
        name: source.source,
      };
    }) || [];

  // Transform API data to the format needed for dropdown
  const leadAgentOptions =
    leadAgents?.map((agent) => {
      return {
        id: agent.id,
        name: agent.agents,
      };
    }) || [];

  async function Savefollowup() {
    const formData = new FormData();
    const time = new Date();
    formData.append("follow_agent", follow_agent); // Make sure `follow_agent` is defined
    formData.append("follow_date", follow_date); // Ensure `follow_date` is in the correct format
    formData.append("assigned_by", userData.empid); // `userData.empid` should be defined
    formData.append("assigned_at", time);

    try {
      await leadSalesApis.followUpbyId(openMenuId, formData); // Ensure `openMenuId` is valid
      showAlert("Followup updated successfully", "success");
      handleUpdateCloseFollow(); // Close the modal or dialog
      getData(); // Refresh data after successful save
    } catch {
      showAlert("Failed to update leads", "error");
    }
  }

  async function SaveDate() {
    try {
      const formData = new FormData();

      // Append each item property to the FormData object
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          formData.append(key, item[key]); // Ensure `item` is correctly defined
        }
      }

      await leadsApis.add(formData); // Add lead using the API
      showAlert("Leads Added successfully", "success");
      getData(); // Refresh data after successful save
      const formObject = {};
      for (const [key, value] of formData.entries()) {
        formObject[key] = value;
      }
      setLeadFiles([formObject, ...leadFiles]); // Add new lead files to state
      setOpen(false); // Close the dialog/modal
    } catch {
      showAlert("An error occurred", "error");
    }
  }

  async function fetchLeadAgents() {
    try {
      const response = await LeadAgentsSettingsApi.getAll(
        pageValue,
        rowsPerPage
      );
      setLeadAgents(response?.data);
      console.log("Lead agents fetched:", response?.data);
    } catch (error) {
      console.error("Error fetching lead agents:", error);
      showAlert("Error loading lead agents", "error");
    }
  }

  async function fetchLeadSources() {
    try {
      const response = await LeadSourceSettingsApi.getAll(
        pageValue,
        rowsPerPage
      );
      setLeadSources(response?.data);
      console.log("Lead sources fetched:", response?.data);
    } catch (error) {
      console.error("Error fetching lead sources:", error);
      showAlert("Error loading lead sources", "error");
    }
  }

  useEffect(() => {
    getData();
    fetchLeadSources();
    fetchLeadAgents();
  }, [
    rowsPerPage,
    pageValue,
    searchValue,
    selectionStatus,
    startDate,
    endDate,
  ]);
  async function getData() {
    const result = await leadsApis.getAll(
      pageValue,
      rowsPerPage,
      selection?.props?.value,
      searchValue,
      selectionStatus?.props?.value,
      startDate,
      endDate
    );
    if (result.success) {
      setLeadFiles(result?.data.data);
      setTotalPages(result?.data.total_pages);
      setRowCountValue(result?.data.total_records);
    } else {
      showAlert(`${result.message}`, "error");
      console.log(`Error ${result.status}: ${result.message}`);
    }
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  //adding follow up
  const fetchData = async () => {
    try {
      const data = await leadsApis.getUserData();
      console.log("Fetched Data:", data);
      setOptionsAgent(data.map((item) => item.name));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  console.log("optionsAgent:", optionsAgent);

  useEffect(() => {
    getData();
  }, []);

  const handleFollowup = () => {
    handleClickFollowup();
  };
  const columns = [
    {
      name: "id",
      label: "Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Name
            </th>
          );
        },
        customBodyRender: (value) => {
          const fullRecord = leadFiles.find((item) => item.id === value);
          if (!fullRecord) {
            return <div>---</div>;
          }

          return (
            <div
              key={value}
              style={{
                textAlign: "center",
                cursor: "pointer",

              }}
              onClick={async () => {
                try {
                  const rowData = await leadsApis.viewMoreById(fullRecord.id);
                  navigate(`/leads/${fullRecord.id}`, { state: rowData.data });
                } catch (error) {
                  console.error("Error fetching lead details:", error);
                  showAlert("Error loading lead details", "error");
                }
              }}
            >
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.name || "Unknown"}
                </div>
                <div style={{ color: "gray" }}>
                  {fullRecord.address || "Unknown"}
                </div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "Phone No.",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Phone No.
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Role
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {categoryType[value]}
            </div>
          );
        },
      },
    },
    {
      name: "follow_agent_details",
      label: "Followed By",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Followed By
            </th>
          );
        },
        customBodyRender: (value) => {
          if (value === null) {
            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                ---
              </span>
            );
          }

          const imageUrl = `${config.apiImageUrl}${value?.image}`;
          return (
            <div
              key={value?.name}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt={value?.name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {value?.name || "Unknown"}
                </div>
                <div style={{ color: "gray" }}>{value?.role || "Unknown"}</div>
              </div>
            </div>
          );
        },
      },
    },

    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];

          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Select
                value={value}
                onChange={(event) => handleChangeSelected(event, ticketId)}
                displayEmpty
                renderValue={(selected) => {
                  if (selected === "1") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Valid
                      </MenuItem>
                    ); // Placeholder text
                  }
                  if (selected === "2") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Invalid
                      </MenuItem>
                    ); // Placeholder text
                  }
                  if (selected === "0") {
                    return (
                      <MenuItem sx={{ display: "flex", alignItems: "center" }}>
                        Converted
                      </MenuItem>
                    ); // Placeholder text
                  }
                  return selected; // Show selected value
                }}
                sx={{
                  width: "110px",
                  border: "none",
                  color: "#000 ",
                  bgcolor: "#fff",
                  "& .MuiSelect-select": {
                    padding: 0,
                  },
                }}
              >
                <MenuItem
                  value={1}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Valid
                </MenuItem>
                <MenuItem
                  value={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Invalid
                </MenuItem>
                <MenuItem
                  value={0}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Converted
                </MenuItem>
              </Select>
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "0", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "0" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userPermissions?.sales_view !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleViewMore(value)}
                        className="MenuItemValue"
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <RemoveRedEyeIcon /> View More
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.sales_note !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => {
                          // handleSaleNote(value);
                        }}
                        className="MenuItemValue"
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EventNoteIcon /> Note
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.sales_follow_up !== 0 && (
                    <MenuItem
                      onClick={handleCloseMenu}
                      className="MenuItemValue"
                    >
                      <div
                        onClick={() => handleFollowup(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <GroupAddIcon /> Follow up
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];
  async function handleEdit() {
    const result = leadFiles.filter((lead) => lead.id === openMenuId);
    setData(result[0]);
    handleClickUpdate();
  }
  useEffect(() => {
    setUpdatename(data.name);
  }, [data.name]);

  useEffect(() => {
    setUpdatephone(data.phone);
  }, [data.phone]);

  useEffect(() => {
    setUpdateemail(data.email);
  }, [data.email]);

  useEffect(() => {
    setUpdateaddress(data.address);
  }, [data.address]);

  useEffect(() => {
    setUpdatelead_agent(data.lead_agent);
  }, [data.lead_agent]);

  useEffect(() => {
    setUpdateleas_source(data.leas_source);
  }, [data.leas_source]);

  useEffect(() => {
    setUpdatelanguage(data.language);
  }, [data.language]);

  useEffect(() => {
    setUpdaterole(data.role);
  }, [data.role]);

  async function UpdateData() {
    const formData = new FormData();
    formData.append("name", updatename);
    formData.append("email", updateemail);
    formData.append("language", updatelanguage);
    formData.append("address", updateaddress);
    formData.append("lead_agent", updatelead_agent);
    formData.append("leas_source", updateleas_source);
    formData.append("role", updaterole);
    formData.append("phone", updatephone);
    try {
      await leadsApis.updatebyId(data.id, formData);
      showAlert("Leads updated successfully", "success");
      handleUpdateClose();
      getData();
    } catch {
      showAlert("Failed to update leads", "error");
    }
  }
  const theme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            backgroundColor: "lightblue", // Change this to your desired color
          },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          root: {
            backgroundColor: "lightblue", // Change this to your desired color
          },
        },
      },
    },
  });
  async function handleDelete(id) {
    const response = await fetch(" " + id, {
      method: "DELETE",
    });
    const result = await response.json(); // Assigning to a new variable

    getData();
    showAlert(" Deleted successfully", "warning");
  }

  // end delete

  const rowsPerPageOptions = [5, 10, 25, 100];
  const options = {
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    totalPages: totalPages, // Adding total pages
    onChangePage: (currentPage) => {
      setPageValue(currentPage + 1);
    },
    customFooter: (
      rowCountValue,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {page * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => changeRowsPerPage(Number(e.target.value))}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {page + 1} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => changePage(page + 1)}
                disabled={page + 1 === totalPages}
                sx={{
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <LeadsHeader
        startDate={startDate}
        selection={selection}
        setSelection={setSelection}
        selectionStatus={selectionStatus}
        setSelectionStatus={setSelectionStatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setErrorMessage={setErrorMessage}
      />
      <LeadDialog
        open={selectedRow.open}
        handleClose={handleDailogClosing}
        rowData={selectedRow}
      />
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <Box sx={{ zIndex: 11000 }}>
        <Dialog
          fullWidth
          maxWidth="md"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component="div">
                Update Lead
              </Typography>
            </Toolbar>
          </AppBar>

          <Box sx={{ backgroundColor: "white" }}>
            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Name
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="ex. abc"
                      value={updatename}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdatename(newValue);
                      }}
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          color: "black",
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Email
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Email"
                        value={updateemail}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setUpdateemail(newValue);
                        }}
                        inputProps={{
                          style: {
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                          },
                        }}
                        InputLabelProps={{ style: { color: "black" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderColor: "black",
                            "&:hover fieldset": {
                              borderColor: "black",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black",
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            "&::placeholder": { color: "gray" },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Phone No.
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="0000000000"
                      type="number"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updatephone}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdatephone(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Language
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Hindi..."
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updatelanguage}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdatelanguage(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Lead Agent
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <TextField
                      // variant="outlined"
                      fullWidth
                      placeholder="Lead agents..."
                      type="email"
                      select
                      value={updatelead_agent}
                      onChange={(e) => setUpdatelead_agent(e.target.value)}
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    >
                      <MenuItem disabled value="">
                        ----
                      </MenuItem>
                      {leadAgentOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Lead Source
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      required
                      select
                      value={leas_source}
                      onChange={handleLeadSourceChange}
                      fullWidth
                      style={{
                        color: "black",
                        border: "1px solid black",
                        borderRadius: "5px",
                      }}
                      placeholder="lead source"
                      type="text"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    >
                      <MenuItem disabled value="">
                        ----
                      </MenuItem>
                      {leadSourceOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              style={{ color: "black", margin: "10px" }}
            >
              <Grid item xs={8} sm={5}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Address
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="e.g.Address"
                      inputProps={{
                        style: {
                          color: "black",
                          border: "1px solid black",
                          borderRadius: "5px",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      value={updateaddress}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setUpdateaddress(newValue);
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={8} sm={3}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Category
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      required
                      select
                      value={updaterole}
                      onChange={handleGenderChangeupdate}
                      fullWidth
                      style={{
                        color: "black",
                        border: "1px solid black",
                        borderRadius: "5px",
                      }}
                      placeholder="Own"
                      inputProps={{
                        style: {
                          color: "black",
                        },
                      }}
                      InputLabelProps={{ style: { color: "black" } }}
                      sx={{
                        "& .MuiSelect-root": {
                          color: "black", // Set text color to black for the selected option
                        },
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black", // Set border color to black
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          "&::placeholder": { color: "gray" }, // Set placeholder color to gray
                          color: "black", // Set text color to black
                        },
                      }}
                    >
                      {categoryKeys.map((option) => (
                        <MenuItem key={option} value={option}>
                          {categoryType[option]}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              autoFocus
              color="inherit"
              onClick={UpdateData}
              sx={{
                backgroundColor: "blue",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                margin: "25px",
              }}
            >
              Update
            </Button>
          </Box>
        </Dialog>
      </Box>
      {/* Follow up box  */}
      <Box sx={{ zIndex: 11000 }}>
        <Dialog
          open={followup}
          fullWidth
          maxWidth="md"
          onClose={handleUpdateCloseFollow}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateCloseFollow}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component="div">
                Follow Up
              </Typography>
            </Toolbar>
          </AppBar>

          <Box sx={{ backgroundColor: "white" }}>
            <Grid
              container
              spacing={2}
              style={{
                color: "black",
                margin: "10px",
              }}
            >
              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Agent
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Autocomplete
                      options={optionsAgent}
                      sx={{ border: "1px solid gray", borderRadius: "5px" }}
                      value={follow_agent}
                      onChange={(event, newValue) => {
                        setFollow_agent(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          fullWidth
                          placeholder="ex. abc"
                          inputProps={{
                            ...params.inputProps,
                            style: {
                              color: "black",
                            },
                          }}
                          InputLabelProps={{
                            style: {
                              color: "black",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Date
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <ThemeProvider theme={theme}>
                      <CssBaseline />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Date"
                          PaperProps={{
                            sx: {
                              "& .MuiPickersCalendarHeader-root": {
                                backgroundColor: "lightblue", // Change this to your desired color
                              },
                              "& .MuiPickersDay-root": {
                                backgroundColor: "lightblue", // Change this to your desired color
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </ThemeProvider>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              autoFocus
              color="inherit"
              onClick={Savefollowup}
              sx={{
                backgroundColor: "blue",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                margin: "25px",
              }}
            >
              Update
            </Button>
          </Box>
        </Dialog>
      </Box>
      <List
        style={{
          background: "none",
          padding: 5,
        }}
      >
        <ListItemText
          style={{ background: "none", margin: 5, zIndex: 1000000 }}
        >
          <React.Fragment>
            <StatusAlert
              open={alertOpen}
              setOpen={setAlertOpen}
              message={alertMessage}
              severity={alertSeverity}
            />
            {userPermissions?.leads_add !== 0 && (
              <Box
                onClick={handleOpenAddModal}
                sx={{
                  backgroundColor: "#1d82f5",
                  "&:hover": { backgroundColor: "orange" },
                  textAlign: "center",
                  padding: "10px",
                  height: "40px",
                  width: "105px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                }}
              >
                <AddIcon />
                Add Lead
              </Box>
            )}

            {/* <Dialog
              fullWidth
              maxWidth="md"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  background: "#141b2d",
                  top: "0",
                  backgroundColor: "white",
                  maxHeight: "95%",
                  margin: "auto",
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                    component="div"
                  >
                    Add Lead
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box
                sx={{
                  backgroundColor: "white",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={11} sm={5.5} md={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Name
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          required
                          fullWidth
                          placeholder="name"
                          onChange={(e) => setName(e.target.value)}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={5.5} md={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Email
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="email.."
                          onChange={(e) => setEmail(e.target.value)}
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={5.5} md={3}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Phone No.
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="+91-0000000000"
                          type="number"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setPhone(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={11} sm={5.5} md={3}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Language
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="Hindi..."
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setLanguage(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={5.5} md={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Lead Agent
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          select
                          value={lead_agent}
                          onChange={handleLeadAgentChange}
                          fullWidth
                          style={{
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                          }}
                          placeholder="lead agent"
                          type="text"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        >
                          <MenuItem disabled value="">
                            ----
                          </MenuItem>
                          {leadAgentOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={11} sm={5.5} md={4}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Lead Source
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          select
                          value={leas_source}
                          onChange={handleLeadSourceChange}
                          fullWidth
                          style={{
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                          }}
                          placeholder="lead source"
                          type="text"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        >
                          <MenuItem disabled value="">
                            ----
                          </MenuItem>
                          {leadSourceOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ color: "black", margin: "10px" }}
                >
                  <Grid item xs={11} sm={5.5} md={8}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Address
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          fullWidth
                          placeholder="e.g.Address"
                          inputProps={{
                            style: {
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "5px",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          onChange={(e) => setAddress(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black",
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={11} sm={5.5} md={3}>
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Category
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <TextField
                          required
                          select
                          value={role}
                          onChange={handleGenderChange}
                          fullWidth
                          style={{
                            color: "black",
                            border: "1px solid black",
                            borderRadius: "5px",
                          }}
                          placeholder="Own"
                          inputProps={{
                            style: {
                              color: "black",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          sx={{
                            "& .MuiSelect-root": {
                              color: "black", // Set text color to black for the selected option
                            },
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black", // Set border color to black
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                            "& .MuiOutlinedInput-input": {
                              "&::placeholder": { color: "gray" }, // Set placeholder color to gray
                              color: "black", // Set text color to black
                            },
                          }}
                        >
                          {categoryKeys.map((option) => (
                            <MenuItem key={option} value={option}>
                              {categoryType[option]}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container sx={{ padding: "20px 0 30px 20px" }}>
                  <Grid item xs={11} className="messageFooter">
                    <Box className="response" onClick={SaveDate}>
                      Save
                    </Box>
                    <Box className="cancel" onClick={handleClose}>
                      Cancel
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Dialog> */}
          </React.Fragment>
        </ListItemText>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Leads Lists
                </span>
              }
              data={leadFiles}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
        <AddLead
    open={openAddModal}
    handleClose={handleCloseAddModal}
    onLeadAdded={handleLeadAdded}
  />
    </>
  );
}

export default Leads;
